import { getTime } from 'date-fns';

export class FpsCounter {
  counter: number;
  timer: number;
  fps: number;

  constructor() {
    this.counter = 0;
    this.timer = getTime(new Date());
    this.fps = 0;
  }

  tick() {
    this.counter++;
    const newTime = getTime(new Date());
    if (newTime - this.timer > 1000) {
      this.fps = this.counter;
      this.counter = 0;
      this.timer = newTime;
    }
  }

  getFPS() {
    return this.fps;
  }
}
